import { Component, Input } from '@angular/core';
import { ValuatedPropertySimilarPropertyModel } from '../../../modules/valuation-report/models/valuation-report.models';

@Component({
  selector: 'app-third-party-property-card',
  templateUrl: './third-party-property-card.component.html',
  styleUrls: ['./third-party-property-card.component.scss'],
})
export class ThirdPartyPropertyCardComponent {
  @Input({ required: true }) details: ValuatedPropertySimilarPropertyModel;
  @Input() url: string;
  @Input() disableHoverEffects = false;
}
